import React from 'react'
import { Route } from 'react-router'
import start, { AppMain } from './public/App'

import Login from './business/Login'
import ForgetPassword from './business/ForgetPassword'
import SetPassword from './business/SetPassword'
import ChangePasswordUnLogin from './business/ChangePasswordUnLogin'
import WeixinLayout from './business/WeixinLayout'
import SupplierInformationWrite from './business/SupplierInformationWrite'

const App = (props) => {
	return <AppMain {...props}>
		<Route exact path="/Login" component={Login} />
		<Route exact path="/ForgetPassword" component={ForgetPassword} />
		<Route exact path="/SetPassword/:token" component={SetPassword} />
		<Route exact path="/ChangePasswordUnLogin/:name" component={ChangePasswordUnLogin} />
		<Route path="/SupplierInformationWrite/:token" component={SupplierInformationWrite} />
		<Route path="/QYWX/" component={WeixinLayout} />
	</AppMain>
}

Tyan.onReady(() => {
	Tyan.menus.version = 2
	// Tyan.sysConfig.autoLock = 15
	require('./menus')
	start({ App, title: '实验室信息管理系统4.0', systemName: "LIMS4.0 - 实验室信息管理系统", companyName: "" })
})                                                      